import { useEffect, useState } from "react";

export type ColumnBreakpoint = { minWidth: number; columns: number };

/**
 * Column count derived from an element's own width, so a virtualized grid chunks
 * rows to match what the container actually shows — unlike a viewport-based
 * measure, which disagrees when the picker sits in a narrow panel on a wide
 * screen. `breakpoints` must be sorted widest-first and stable across renders.
 */
export function useElementColumns(
  el: HTMLElement | null,
  breakpoints: ColumnBreakpoint[]
): number {
  const [columns, setColumns] = useState(1);

  useEffect(() => {
    if (!el) {
      return;
    }
    const update = () => {
      const width = el.clientWidth;
      setColumns(breakpoints.find((b) => width >= b.minWidth)?.columns ?? 1);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [el, breakpoints]);

  return columns;
}
